module.exports = __webpack_public_path__ + "static/media/clare-example.e28c5a17.png";